import * as Types from '@/store/types'
import store from '@/store'

class Stat {
  constructor() {
    this.track = this.track.bind(this)
  }

  track(data, store) {
    store.dispatch(`stats/${Types.ADD_STAT}`, data)
  }
}

const stater = new Stat()

const install = Vue => {
  Vue.prototype.$stat = options => {
    store.dispatch(`stats/${Types.ADD_STAT}`, options)
  }
  Vue.directive('stat', {
    bind: (el, binding) => handleDirective(el, binding, 'bind', stater.track),
    unbind: (el, binding) =>
      handleDirective(el, binding, 'unbind', stater.track)
  })
}

const handleDirective = (el, binding, vnode, hook, handler) => {
  const { arg: event = 'exposure', value: data } = binding
  const { context } = vnode
  let isExposure = event === 'exposure'
  if (hook === 'bind') {
    isExposure
      ? handler(data, context.$store)
      : bindEvent(el, event, () => handler(data, context.$store))
  }
  if (hook === 'unbind' && !isExposure) {
    removeEvent(el, event, handler)
  }
}

const bindEvent = (element, type, handler) => {
  if (element.addEventListener) {
    element.addEventListener(type, handler, false)
  } else if (element.attachEvent) {
    element.attachEvent('on' + type, handler)
  } else {
    element['on' + type] = handler
  }
}

// 移除事件绑定
const removeEvent = (element, type, handler) => {
  if (element.removeEventListener) {
    element.removeEventListener(type, handler, false)
  } else if (element.detachEvent) {
    element.detachEvent('on' + type, handler)
  } else {
    element['on' + type] = null
  }
}

export default { install }
